import Axios from 'axios'
import URL from '../config/url'
import { Message } from 'element-ui'

const baseURL = URL.API

const service = Axios.create({ withCredentials: false, baseURL })

// 请求拦截器
service.interceptors.request.use(config => {
    config.headers["token"] = localStorage.getItem("token") ? localStorage.getItem("token") : ""
    config.headers["organ"] = localStorage.getItem("organ") ? localStorage.getItem("organ") : ""
    config.headers["actor"] = localStorage.getItem("actor") ? localStorage.getItem("actor") : ""
    config.headers["branch"] = localStorage.getItem("branch") ? localStorage.getItem("branch") : ""
    config.headers["channel"] = localStorage.getItem("channel") ? localStorage.getItem("channel") : 1
    config.headers["source-host"] = "admin"
    config.headers["locale"] = localStorage.getItem("current_language")
    config.headers["_timezone"] = localStorage.getItem("timezone")
    return config
}, err => {
    return Promise.reject(err)
})

// 响应拦截器
service.interceptors.response.use(
	(config) => {
		return config
	},
	(err) => {
		if (err.message.includes('timeout') || err.message.includes('Network Error')) {
			stackArr.push(`网络异常，请重新尝试`)
		}
		if (!isPoint) {
			isPoint = true
			loop()
		}

		return Promise.reject(err)
	}
)
let stackArr = []
let isPoint = false
let type = 'error'
function message() {
	if (stackArr[0] == '您的密码长时间未更换，请更换密码') {
		type = 'info'
	}
	Message({
		message: stackArr[0],
		type: type,
		duration: 2000,
		onClose: () => {
			stackArr.shift()
			if (stackArr.length) {
				loop()
			} else {
				isPoint = false
			}
		},
	})
}
function loop() {
	if (stackArr.length < 2) {
		message()
	} else {
		setTimeout(() => {
			message()
		}, 2500)
	}
}

function API(config) {
	const {
		url = '',
		data = null,
		params = null,
		headers = {
			'content-type': 'application/json',
		},
		method = 'get',
		timeout = 30000,
	} = config || {}
	return new Promise((resolve, reject) => {
		service({
			method, // 请求方式
			url, // 请求路径
			timeout, // 请求超时
			headers, // header体
			data, // body参数
			params, //  URL参数
		})
			.then((res) => {
				if (res.data.code && res.data.code !== 50001) {
					if (!stackArr.includes(res.data.message)) {
						stackArr.push(res.data.message)
					}
					if (!isPoint) {
						isPoint = true
						loop()
					}
					// 接口提示请先登录 或者 登录信息失效 跳转登录页
					if (+res.data.code === 303 || +res.data.code === 10000) {
                        localStorage.clear()
                        sessionStorage.clear()
                        window.location = `//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/entrance/login`
						resolve('跳转登录页')
					}
				}
				resolve({
					...res.data,
					headers: res.headers,
				})
			})
			.catch((err) => {
				reject(err)
				return err
			})
	})
}

export default API
